function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import throttle from 'lodash/throttle';
import toLower from 'lodash/toLower';
import Form from 'components/Form';
import FormGroup from 'components/Form/FormGroup';
import Input from 'components/Form/Input';
import Loupe from 'svg/loupe.svg';
import App from 'modules/App';
import * as actions from '../../actions';
import * as constants from '../../constants';
import messages from '../../messages';
import styles from './SearchClinics.pcss';
var _React_PureComponent;
class SearchClinics extends (_React_PureComponent = React.PureComponent) {
    componentDidUpdate(prevProps) {
        const { activeClinicMembership } = this.props;
        if (prevProps.activeClinicMembership !== activeClinicMembership) {
            this.onChange({
                id: `${this.props.forId}-search`,
                value: ''
            });
        }
    }
    onBlur() {
        if (this.props.clearOnBlur) {
            setTimeout(()=>this.onChange({
                    id: `${this.props.forId}-search`,
                    value: ''
                }), 300);
        }
    }
    onChange(input) {
        this.props.onSetFormValue(input);
        this.onSetSearch(toLower(input.value));
    }
    render() {
        return /*#__PURE__*/ _jsxs(Form, {
            className: styles.searchPatients,
            children: [
                /*#__PURE__*/ _jsx(FormGroup, {
                    id: `${this.props.forId}-search`,
                    className: styles.searchPatients__formGroup,
                    formValues: this.props.formValues,
                    children: /*#__PURE__*/ _jsx(Input, {
                        placeholder: messages.placeholders.searchClinics,
                        className: styles.searchPatients__formGroup__input,
                        attributes: {
                            autoComplete: 'off'
                        },
                        onChange: (input)=>this.onChange(input),
                        onBlur: ()=>this.onBlur()
                    })
                }),
                /*#__PURE__*/ _jsx(Loupe, {
                    className: styles.searchPatients__icon
                })
            ]
        });
    }
    constructor(props){
        super(props);
        this.onSetSearch = throttle((phrase)=>props.onSetSearch(props.forId, phrase), 300);
    }
}
_define_property(SearchClinics, "propTypes", {
    // Explicit props
    forId: PropTypes.string.isRequired,
    activeClinicMembership: PropTypes.object,
    clearOnBlur: PropTypes.bool,
    // Implicit props
    formValues: PropTypes.object,
    // Implicit actions
    onSetSearch: PropTypes.func,
    onSetFormValue: PropTypes.func
});
const mapStateToProps = (state, props)=>({
        formValues: App.selectors.formSelector(props.formName || constants.SEARCH_CLINICS_FORM)(state)
    });
const mapDispatchToProps = (dispatch, props)=>{
    const formName = props.formName || constants.SEARCH_CLINICS_FORM;
    return {
        onSetSearch: (forId, phrase)=>dispatch(actions.setClinicsSearch(forId, phrase)),
        onSetFormValue: (input)=>dispatch(App.actions.setFormValue(formName, input)),
        onFormErrors: (errors)=>dispatch(App.actions.setFormErrors(formName, errors)),
        onFormProcessing: ()=>dispatch(App.actions.startFormProcessing(formName)),
        onClearForm: ()=>dispatch(App.actions.clearForm(formName))
    };
};
const ConnectedSearchClinics = connect(mapStateToProps, mapDispatchToProps)(SearchClinics);
export default withStyles(styles)(ConnectedSearchClinics);
